import React, { useState } from "react";
import ModalSignUp from "./ModalSignUp";
import logoEscudo from "../images/logoEscudo.png";
import ModalLogIn from "./ModalLogIn";
import ModalPasswordRecover from "./ModalPasswordRecover";
import CryptoJS from 'crypto-js'
import { KEY } from "../config";
import SuccessAlert from './SuccessAlert';
import NavBar from "./navBar";


const TittleNavBar = () => {
  const [successAlert, setSuccessAlert] = useState(null)
  const [isModalSignUpOpen, setIsModalSignUpOpen] = useState(false)
  const [isModalLogInOpen, setIsModalLogInOpen] = useState(false)
  const [isModalPasswordRecoverOpen, setIsModalPasswordRecoverOpen] = useState(false)

  const decryptSession = () => {
    const session = window.localStorage.getItem("session");
    if (session) {
      const bytes = CryptoJS.AES.decrypt(session, KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    }
  }

  const decryptUserRole = () => {
    const userRole = window.localStorage.getItem("userRole");
    if (userRole) {
      const bytes = CryptoJS.AES.decrypt(userRole, KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    }
  }

  const logOut = () => {
    window.localStorage.removeItem("session");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("userRole");
    window.location.assign("/");
  }

  return (

    <>
      <ModalLogIn isModalLogInOpen={isModalLogInOpen} setIsModalLogInOpen={setIsModalLogInOpen} setIsModalSignUpOpen={setIsModalSignUpOpen} setIsModalPasswordRecoverOpen={setIsModalPasswordRecoverOpen} />
      <ModalPasswordRecover isModalPasswordRecoverOpen={isModalPasswordRecoverOpen} setIsModalPasswordRecoverOpen={setIsModalPasswordRecoverOpen} setIsModalLoginOpen={setIsModalLogInOpen} setSuccessAlert={setSuccessAlert} />
      <ModalSignUp isModalSignUpOpen={isModalSignUpOpen} setIsModalSignUpOpen={setIsModalSignUpOpen} setIsModalLogInOpen={setIsModalLogInOpen} setSuccessAlert={setSuccessAlert} />
      <SuccessAlert isVisible={successAlert}/>
      <nav className="flex items-center bg-white justify-between z-10 p-1 sticky top-0 w-full shadow-md ">
        
        <div className="px-3 2xl:px-8 h-full flex 2sm:flex-col 2md:flex-row w-full flex-row ">
          <div className=" flex w-[50%] sm:w-[25%] md:w-[30%] lg:w-[25%] py-2.5 items-center">
            <a href="https://www.alcaldianeiva.gov.co/" target="_blank" rel="noreferrer" >
              <img className="h-[50px] md:h-[60px] lg:h-full" src={logoEscudo} alt="Logo escudo Neiva" />
            </a>
          </div>
        <div className="flex flex-col order-first 2sm:order-none  md:w-full ">
          <div className="flex sm:flex-row flex-col  justify-end 2sm:absolute 2sm:top-7 2sm:right-4 2md:static">
            <div className="text-center py-3 grow hidden lg:block">
              <span className="font-bold text-lg">
                DIRECCIÓN DE GESTION CATASTRAL
              </span>
            </div>
            {(decryptSession() === "true") ? (
          
           <div className="flex gap-6 relative items-center hidden 2sm:flex">
              {decryptUserRole() === "1" && (
                <button onClick={() => window.location.assign("/control")} className="flex items-center text-[#0eaf58] text-sm font-semibold hover:underline">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                  </svg>
                  Panel de Control
                </button>)
              }
              <button onClick={() => window.location.assign("/perfil")} className=" flex items-center text-[#0eaf58] text-sm font-semibold hover:underline">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                Mi Perfil
              </button>
              <button onClick={() => logOut()} className=" flex items-center text-[#0eaf58] text-sm font-semibold hover:underline">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" />
                </svg>
                Cerrar Sesión
              </button>
          </div>
        ) : (
          <div className="flex gap-6 relative items-center hidden 2sm:flex ">
            <button onClick={() => setIsModalSignUpOpen(true)} className="flex items-center text-[#0eaf58] text-sm font-semibold hover:underline">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 mr-1">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
              </svg>
              Registrate
            </button>

            <button onClick={() => setIsModalLogInOpen(true)} className=" flex items-center text-[#0eaf58] text-sm font-semibold hover:underline">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none" viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 mr-1">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
              </svg>
              Iniciar Sesión
            </button>
          </div>)}
          </div>
          <NavBar decryptUserRole={decryptUserRole} decryptSession={decryptSession} logOut={logOut} setIsModalLogInOpen={setIsModalLogInOpen} setIsModalSignUpOpen={setIsModalSignUpOpen} />
          </div>  
          
          </div>
      </nav>
    </>
  );
};

export default TittleNavBar;
